import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Flex, FlexColumn, Box, Button, Text, Tooltip, MenuItem, Spinner } from 'core/components';
import storeLoader from 'app/stores/storeLoader';

/**
 * Silences can no longer be created; suppressions replace them. This control only removes an
 * existing silence, so it renders nothing for an alert that is not already silenced.
 */
@storeLoader('$alerting.silenceCollection')
@inject('$auth', '$dictionary', '$metrics')
@observer
export default class SilenceAlertButton extends Component {
  static defaultProps = {
    comment: '',
    disabled: false
  };

  state = {
    requestPending: false
  };

  handleRemoveSilence = (model) => {
    this.setState({ requestPending: true });
    model.destroy().then(() => {
      this.setState({ requestPending: false });
    });
  };

  get silenceModel() {
    const { alertModel } = this.props;
    return alertModel.silenceModel;
  }

  get isSilenced() {
    return Boolean(this.silenceModel);
  }

  renderTooltipText = () => {
    const { startTime, startDetails, expirationDetails } = this.silenceModel;

    return startDetails.started ? (
      <>
        <Text>Alert is already silenced:</Text>
        <Text>
          <b>Started:</b> {startTime} ({startDetails.diff} ago)
        </Text>
        <Text>
          <b>Ends:</b> {expirationDetails.expirationDay} (in {expirationDetails.duration})
        </Text>
      </>
    ) : (
      <>
        <Text>Alert has a pending silence:</Text>
        <Text>
          <b>Starts:</b> {startTime} (in {startDetails.diff})
        </Text>
        <Text>
          <b>Ends:</b> {expirationDetails.expirationDay} (in {expirationDetails.duration})
        </Text>
      </>
    );
  };

  render() {
    const { $auth, asMenuItem, buttonProps, disabled } = this.props;
    const { requestPending } = this.state;

    if (!this.isSilenced) {
      return null;
    }

    const isAllowedToDeleteSilence = $auth.hasRbacPermissions(['alerting.silences::delete']);
    const buttonText = 'Unsilence Notifications';
    const onClick = () => this.handleRemoveSilence(this.silenceModel);

    const ButtonComp = (
      <Button
        mr={0}
        width="100%"
        icon="notifications"
        onClick={onClick}
        disabled={requestPending || !isAllowedToDeleteSilence || disabled}
        {...buttonProps}
        text={
          <Flex gap={1}>
            {buttonText}
            {requestPending && <Spinner size={16} />}
          </Flex>
        }
      />
    );

    const MenuItemComp = (
      <MenuItem
        icon="notifications"
        disabled={requestPending || !isAllowedToDeleteSilence || disabled}
        text={
          <Flex gap={1}>
            {buttonText}
            {requestPending && <Spinner size={16} />}
          </Flex>
        }
        onClick={onClick}
      />
    );

    const ClickElement = asMenuItem ? MenuItemComp : ButtonComp;

    return requestPending ? (
      ClickElement
    ) : (
      <Box>
        <Tooltip fill content={<FlexColumn>{this.renderTooltipText()}</FlexColumn>}>
          {ClickElement}
        </Tooltip>
      </Box>
    );
  }
}
